import { render, staticRenderFns } from "./SupportMessage.vue?vue&type=template&id=120f239a&"
import script from "./SupportMessage.vue?vue&type=script&lang=js&"
export * from "./SupportMessage.vue?vue&type=script&lang=js&"
import style0 from "./SupportMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports